/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Box, makeStyles, Typography } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import clsx from 'clsx';
import { useLinkStyles } from '../../components/common/useLinkStyles';

const useStyles = makeStyles(() => ({
  userLink: {
    display: 'flex',
    alignItems: 'center',
  },
}));

function UserMenuProfile({ userLink, user, to, showIcon, onClick }) {
  const classes = useStyles();
  const linkClass = useLinkStyles();

  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="inherit" component="h4">
        {user}
      </Typography>
      <Typography variant="inherit" component="h4">
        <Link to={to} onClick={onClick} className={clsx(linkClass.link, classes.userLink)}>
          {userLink}
          {showIcon && <ChevronRightIcon />}
        </Link>
      </Typography>
    </Box>
  );
}

export default UserMenuProfile;
